// The registry publishes a group per room count (1-10) and, since the aggregate rollup, one group covering
// all of them at once. The API encodes that aggregate as an absent `rooms` param - `rooms=0` answers 400 -
// so "all rooms" travels through the app as this sentinel and turns into `undefined` at the query boundary.
// `undefined` is also what the RTK Query cache key needs: JSON.stringify drops it, so an aggregate query
// hashes identically whether the key was omitted or set to undefined. `null` would hash as a third key.
export const ALL_ROOMS = "all";

export type RoomsFilter = number | typeof ALL_ROOMS;

export const isAllRooms = (rooms: RoomsFilter): rooms is typeof ALL_ROOMS => rooms === ALL_ROOMS;

export const toRcnRooms = (rooms: RoomsFilter): number | undefined => (isAllRooms(rooms) ? undefined : rooms);
// The registry publishes a group per room count (1-10) and, since the aggregate rollup, one group covering
// all of them at once. The API encodes that aggregate as an absent `rooms` param - `rooms=0` answers 400 -
// so "all rooms" travels through the app as this sentinel and turns into `undefined` at the query boundary.
// `undefined` is also what the RTK Query cache key needs: JSON.stringify drops it, so an aggregate query
// hashes identically whether the key was omitted or set to undefined. `null` would hash as a third key.
export const ALL_ROOMS = "all";

export type RoomsFilter = number | typeof ALL_ROOMS;

export const isAllRooms = (rooms: RoomsFilter): rooms is typeof ALL_ROOMS => rooms === ALL_ROOMS;

export const toRcnRooms = (rooms: RoomsFilter): number | undefined => (isAllRooms(rooms) ? undefined : rooms);
